import * as React from "react";
// import PropTypes from "prop-types";
// import styled from "styled-components";
import { useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
// import { CircularIndeterminate } from "components/loaders/CircularIndeterminate";
import { Stack } from "@mui/material";

// import FolderOffIcon from "@mui/icons-material/FolderOff";

const DataGridLayout = ({
  children,
  rows,
  columns,
  onCellClick,
  sx,
  checkboxSelection,
  isDataLoading,
}) => {
  const [finalClickInfo, setFinalClickInfo] = useState(null);

  const handleOnCellClick = (params) => {
    const field = params.field; // 비교할 대상 변수로 만들고
    const contractFieldName = "doc"; // 내가 원하는 값을 변수로 만들고
    const excelDownloadFieldName = "file_name";

    if (field === contractFieldName) {
      // alert("계약서 컬럼 셀 선택");
      setFinalClickInfo(params);
      onCellClick(params);
    }
    if (field === excelDownloadFieldName) {
      setFinalClickInfo(params);
      onCellClick(params);
    }
  };

  console.log("finalClickInfo", finalClickInfo);
  // // no data 이미지 E
  const getHeightSX = () => {
    return {
      minHeight: 180, // 최소 높이를 180px로 설정
      // maxHeight: 500,
      maxHeight: 700,
      ...sx,
    };
  };

  return (
    // <Stack>
    <Stack sx={getHeightSX}>
      <DataGrid
        autoHeight
        children={children}
        sx={sx}
        rows={rows}
        columns={columns}
        // baseTooltip
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
        hideFooterSelectedRowCount={true}
        rowHeight={55}
        onCellClick={handleOnCellClick}
        loading={isDataLoading} // 로더 mui
      />
    </Stack>
  );
};

export default DataGridLayout;
